import React from 'react';
import './App.css';
import './utilities/numberExtensions';
import './utilities/dateExtensions';
import 'reflect-metadata';
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { IntlProvider } from "react-intl";
import AppLocale from "./l10n";
import LocalStorageProvider from 'providers/LocalStorageProvider';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'assets/css/scss/base.scss';
import 'assets/css/scss/box.scss';
import 'assets/css/scss/colors.scss';
import 'assets/css/scss/typography.scss';
import "reflect-metadata";
import store from 'states/redux/store'
import { Provider } from 'react-redux'

const Home = React.lazy(() =>
  import(/* webpackChunkName: "views-app" */ "./routes")
);


function App() {

  const l10n = LocalStorageProvider.getL10n();
  const currentAppLocale = AppLocale[l10n];
  return (
    <>
    <Provider store={store}>
      <React.Suspense fallback={<div className="loading-fixed" />}>
        <IntlProvider
          locale={l10n}
          messages={currentAppLocale.messages}
        >
          <BrowserRouter basename="/">
            <React.Suspense fallback={<div className="loading-fixed"></div>}>
              <Routes>
                <Route path="*" element={<Home />} />
              </Routes>
            </React.Suspense>
          </BrowserRouter>
        </IntlProvider>
      </React.Suspense>
    </Provider>

    </>
  );
}

export default App;
